import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formate un pourcentage avec TOUJOURS une décimale (jamais arrondi à
 * l'entier), au format français (virgule décimale). Ex. 99.64 → "99,6",
 * 100 → "100,0". Évite qu'un avancement de 99,6 % s'affiche « 100 % ».
 */
export function formatPercent(value: number): string {
  return value.toLocaleString("fr-FR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })
}
